import { KoncentroBaseModel } from './koncentro-base.model';

export class CalendarItem extends KoncentroBaseModel {
  public dto ?= 'CalendarItemDto';

  public id: number;
  public code: string;
  public description: string;
  public time_range: string;
  public monday: string;
  public tuesday: string;
  public wednesday: string;
  public thursday: string;
  public friday: string;
  public saturday: string;
  public sunday: string;
  public flg_extra_open: string;
}



// WEBPACK FOOTER //
// ./src/app/models/calendar.model.ts